var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01872 0.311621C8.82259 0.117232 8.50601 0.118644 8.31162 0.314776C8.11723 0.510907 8.11864 0.827486 8.31478 1.02188L9.49009 2.18675C9.96708 2.65951 10.2943 2.98487 10.5157 3.26055C10.5876 3.35014 10.6438 3.42902 10.6874 3.50008L0.666748 3.50008C0.390606 3.50008 0.166748 3.72394 0.166748 4.00008C0.166748 4.27622 0.390606 4.50008 0.666748 4.50008L10.6874 4.50008C10.6438 4.57115 10.5876 4.65002 10.5157 4.73961C10.2943 5.0153 9.96708 5.34066 9.49009 5.81341L8.31478 6.97829C8.11864 7.17268 8.11723 7.48926 8.31162 7.68539C8.50601 7.88152 8.82259 7.88293 9.01872 7.68854L10.2152 6.50268C10.6659 6.05605 11.0342 5.69102 11.2954 5.36577C11.567 5.02756 11.7636 4.68426 11.8161 4.27219C11.8277 4.18185 11.8334 4.09096 11.8334 4.00008C11.8334 3.9092 11.8277 3.81832 11.8161 3.72797C11.7636 3.3159 11.567 2.9726 11.2954 2.63439C11.0342 2.30914 10.6659 1.94411 10.2152 1.49747L9.01872 0.311621Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b4efaba51ed68f437a3d6e04b8f8375c.svg";
export { ForwardRef as ReactComponent };